import {ceilToIntegers, ceilToHundredths, ceilToTens} from '../math';
// import {Option} from "../../components/UI";
// import React from "react";
// import {picketBackM} from "../../assets/images";

// FencePicket Штакетник
export const calculateFencePicket_pCalc = (
  dz: number, // ДЗ - длина забора
  vz: string, // ВЗ - высота забора
  picketColor: string, // Цвет штакетника
  picketType: string, // Вид штакетника
) => {
  const k = picketType === 'М-образный' ? 7 : 9; // К - Кратность

  if (['RAL 8017', 'RAL 6005', 'RAL 3005'].includes(picketColor) && ['1.5', '1.8', '2'].includes(vz)) {
    // П = ДЗ×К×ВЗ
    return ceilToIntegers(dz * k * Number(vz));
  } else {
    // П = ОКРУГЛЕНИЕ10(ДЗ×К)×ВЗ
    return ceilToIntegers(ceilToTens(dz * k) * Number(vz));
  }
};
export const calculateFencePicket_kpCalc = (dz: number, kv: string, shv: string, kk: string, shk: string, rs: number) => {
  // КП=(ДЗ-КВ×ШВ-КК×ШК)/РС
  return ceilToIntegers((dz - (Number(kv) * Number(shv)) - (Number(kk) * Number(shk))) / rs);
};
export const calculateFencePicket_sCalc = (kpCalc: number, tp: string) => {
  switch (tp) {
    case 'Замкнутый':
      // С=КП
      return kpCalc;
    case 'Не замкнутый':
      // С=КП+1
      return ceilToIntegers(kpCalc + 1);
    default:
      return 0;
  }
};
export const calculateFencePicket_dsCalc = (sCalc: number, vz: string) => {
  return ceilToIntegers(sCalc * (Number(vz) + 1));
};
export const calculateFencePicket_mCalc = (pCalc: number, picketType: string, vz: string) => {
  // М-образный ? 2 самореза на штакетину(М=П/ВЗ×2): 4 самореза на штакетину(М=П/ВЗ×4)
  const picketsNumber = ceilToIntegers(pCalc / Number(vz))

  if (picketType === 'М-образный') {
    return ceilToIntegers(picketsNumber * 2);
  } else {
    return ceilToIntegers(picketsNumber * 4);
  }
};
export const calculateFencePicket_nCalc = (dz: number, kv: string, shv: string, kk: string, shk: string, pgk: string) => {
  // Н = (ДЗ-КВ×ШВ-КК×ШК)×ПГ
  return ceilToIntegers((dz - (Number(kv) * Number(shv)) - (Number(kk) * Number(shk))) * Number(pgk));
};

export const calculateFencePicket = (
  dz: number, // ДЗ - длина забора
  vz: string, // ВЗ - высота забора
  tp: string, // ТП - тип периметра
  rs: number, // РС - расстояние между столбами
  kv: string, // КВ - количество ворот
  shv: string, // ШВ - ширина ворот
  kk: string, // КК - количество калиток
  shk: string, // ШК - ширина калитки
  pgk: string, // ПГК - параметр горизонталей количество
  picketColor: string, // Цвет штакетника
  picketType: string, // Вид штакетника
) => {
  const pCalc = calculateFencePicket_pCalc(dz, vz, picketColor, picketType); // П - Длина штакетника
  const kpCalc = calculateFencePicket_kpCalc(dz, kv, shv, kk, shk, rs); // КП - количество пролетов
  const sCalc = calculateFencePicket_sCalc(kpCalc, tp); // С - количество столбов

  return {
    pCalc: pCalc, // П - Длина штакетника
    kpCalc: kpCalc, // КП - количество пролетов
    sCalc: sCalc, // С - количество столбов
    dsCalc: calculateFencePicket_dsCalc(sCalc, vz), // ДС - длина столбов
    mCalc: calculateFencePicket_mCalc(pCalc, picketType, vz), // М - количество саморезов
    nCalc: calculateFencePicket_nCalc(dz, kv, shv, kk, shk, pgk), // Н - длина направляющих
  };
};

// FencePailing Профнастил
export const calculateFencePailing_pCalc = (ppvp: string, dz: number): number => {
  if (ppvp === 'С08') {
    // Количество листов П = ДЗ/1,15
    return ceilToIntegers(dz / 1.15)
  } else {
    // С21? Количество листов П = ДЗ/1 , МП20? Количество листов П = ДЗ/1,1
    return ceilToIntegers(dz)
  }
};

export const calculateFencePailing_plCalc = (ppvp: string, vz: string, plCalc: number):number => {
  if (ppvp === 'С08') {
    // Для листа С8: 1,2 × ВЗ × П
    return ceilToHundredths(1.2 * Number(vz) * plCalc);
  } else {
    // Для листов С10: 1,18 × ВЗ × П
    // Для листов С20: 1,165 × ВЗ × П
    // Для С21: 1,051 × ВЗ × П
    return ceilToHundredths(1.051 * Number(vz) * plCalc);
  }
};

export const calculateFencePailing_kpCalc = (ppvp: string, dz: number, kv: string, shv: string, kk: string, shk: string, rs: number) => {
  // КП=(ДЗ-КВ×ШВ-КК×ШК)/РС
  return ceilToIntegers((dz - (Number(kv) * Number(shv)) - (Number(kk) * Number(shk))) / rs);
};

export const calculateFencePailing_sCalc = (kpCalc: number, tp: string) => {
  // console.log('kpCalc', kpCalc)
  switch (tp) {
    case 'Замкнутый':
      // С=КП
      return kpCalc;
    case 'Не замкнутый':
      // С=КП+1
      return kpCalc + 1;
    default:
      return 0;
  }
};

export const calculateFencePailing_dsCalc = (sCalc: number, vz: string) => {
  // ДС=С×(ВЗ+1)
  return ceilToIntegers(sCalc * (Number(vz) + 1));
};

export const calculateFencePailing_mCalc = (pCalc: number) => {
  // М=П×10
  return ceilToIntegers(pCalc * 10);
};

export const calculateFencePailing_nCalc = (dz: number, kv: string, shv: string, kk: string, shk: string, pgk: string) => {
  // Н = (ДЗ-КВ×ШВ-КК×ШК)×ПГ
  return ceilToIntegers((dz - (Number(kv) * Number(shv)) - (Number(kk) * Number(shk))) * Number(pgk));
};

export const calculateFencePailing_kppCalc = (dz: number) => {
  const dpp = 2 // Длина планки 2м
  return ceilToIntegers(dz  / dpp );
};
export const calculateFencePailing = (
  dz: number, // ДЗ - длина забора
  vz: string, // ВЗ - высота забора
  tp: string, // ТП - тип периметра
  rs: number, // РС - расстояние между столбами
  kv: string, // КВ - количество ворот
  shv: string, // ШВ - ширина ворот
  kk: string, // КК - количество калиток
  shk: string, // ШК - ширина калитки
  pgk: string, // ПГК - параметр горизонталей количество
  ppvp: string // Вид профнастила
) => {
  const pCalc = calculateFencePailing_pCalc(ppvp, dz); // П - количество листов профнастила
  const plCalc = calculateFencePailing_plCalc(ppvp, vz, pCalc); // ПЛ - общая площадь листов профнастила
  const kpCalc = calculateFencePailing_kpCalc(ppvp, dz, kv, shv, kk, shk, rs); // КП - количество пролетов
  const sCalc = calculateFencePailing_sCalc(kpCalc, tp); // С - количество столбов
  // console.log('sCalc',sCalc)
  return {
    pCalc: plCalc, // П - количество листов профнастила
    kpCalc: kpCalc, // КП - количество пролетов
    sCalc: sCalc, // С - количество столбов
    dsCalc: calculateFencePailing_dsCalc(sCalc, vz), // ДС - длина столбов
    mCalc: calculateFencePailing_mCalc(pCalc), // М - количество саморезов
    nCalc: calculateFencePailing_nCalc(dz, kv, shv, kk, shk, pgk), // Н - длина направляющих
    kppCalc: calculateFencePailing_kppCalc(dz), // КПП - количество П-планок
  };
};


